import { katTranslator } from '../../shared/i18n';

const strings = {
  kat_skip_link: {
    'en-US': 'Skip to content (press enter)',
    'en-NG': 'Skip to content (press Enter)',
    'nl-NL': 'Ga door naar de inhoud (druk op enter)',
    'bn-IN': 'সরাসরি কনেন্টে যান (এন্টার টিপুন)',
    'te-IN': 'కంటెంట్‌కి దాటవేయి (ఎంటర్ నొక్కండి)',
    'ko-KR': '콘텐츠로 건너뛰기(엔터를 누르세요)',
    'en-IN': 'Skip to content (press enter)',
    'ja-JP': 'スキップしてコンテンツを表示 (Enterキーを押す)',
    'es-ES': 'Saltar al contenido (pulsar Intro)',
    'pt-PT': 'Saltar para os conteúdos (pressionar Enter)',
    'en-AE': 'Skip to content (press enter)',
    'en-GB': 'Skip to content (press Enter)',
    'pl-PL': 'Przejdź do treści (naciśnij enter)',
    'en-AU': 'Skip to content (press enter)',
    'tr-TR': 'İçeriğe atlayın (enter tuşuna basın).',
    'en-CA': 'Skip to content (press enter)',
    'fr-FR': 'Passer au contenu (appuyez sur Entrée)',
    'en-SG': 'Skip to content (press Enter)',
    'fr-BE': 'Passer au contenu (appuyez sur Entrée)',
    'en-ZA': 'Skip to content (press enter)',
    'mr-IN': 'थेट कंटेंट वर जा (एंटर दाबा)',
    'it-IT': 'Salta e vai al contenuto (premi invio)',
    'he-IL': 'לדילוג לתוכן (יש ללחוץ על Enter)',
    'nl-BE': 'Ga naar de inhoud (druk op enter)',
    'zh-TW': '跳到內容 (按 Enter 鍵)',
    'fr-CA': 'Passer au contenu (appuyez sur Entrée)',
    'sv-SE': 'Hoppa till innehåll (tryck på enter)',
    'hi-IN': 'सामग्री पर जाएं (एंटर दबाएं)',
    'pt-BR': 'Pular e acessar o conteúdo (pressione enter)',
    'ml-IN': 'ഉള്ളടക്കത്തിലേക്ക് പോകുക (എന്റർ അമർത്തുക)',
    'ta-IN': 'உள்ளடக்கத்திற்குச் செல்க (Enter ஐ அழுத்தவும்)',
    'cs-CZ': 'Přeskočit na obsah (stiskněte klávesu Enter)',
    'zh-CN': '跳过并前往内容（按回车键）',
    'ar-AE': 'التخطّي إلى المحتوى (اضغط على Enter)',
    'da-DK': 'Spring til indhold (tryk på enter)',
    'es-MX': 'Saltar al contenido (presiona ingresar)',
    'de-DE': 'Zum Inhalt springen (Eingabetaste drücken)',
    'es-CO': 'Saltar al contenido (presiona Enter)',
    'es-CL': 'Saltar al contenido (presiona Enter)',
    'kn-IN': 'ವಿಷಯಕ್ಕೆ ಸ್ಕಿಪ್ ಮಾಡಿ (enter ಒತ್ತಿರಿ)',
    'es-US': 'Saltar al contenido (presiona Enter)',
  },
};

export default katTranslator(strings);
